import { render, staticRenderFns } from "./MarcacaoOnline.vue?vue&type=template&id=763f5f8f&"
import script from "./MarcacaoOnline.vue?vue&type=script&lang=js&"
export * from "./MarcacaoOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports